export type WhatsappBspOnboardingLinkMessages = {
  whatsappBspOnboardingLinkText1: string;
  whatsappBspOnboardingLinkText2: string;
  whatsappBspOnboardingLinkButton: string;
  whatsappBspOnboardingLinkCheckbox: string;
  whatsappBspOnboardingLinkError: string;
  whatsappBspOnboardingLinkRetry: string;
  whatsappBspOnboardingLinkTimeout: string;
  whatsappBspOnboardingLinkChecking: string;
  whatsappBspOnboardingLinkComplete: string;
};

export const whatsappBspOnboardingLinkMessages: WhatsappBspOnboardingLinkMessages = {
  whatsappBspOnboardingLinkText1:
    "Complete seu onboarding no portal para conectar sua conta WhatsApp Business.",
  whatsappBspOnboardingLinkText2:
    "Clique no botão abaixo para abrir o portal e completar o cadastro do seu WhatsApp.",
  whatsappBspOnboardingLinkButton: "Abrir Portal de Onboarding",
  whatsappBspOnboardingLinkCheckbox: "Já completei o onboarding no portal",
  whatsappBspOnboardingLinkError: "Erro ao criar app. Tente novamente.",
  whatsappBspOnboardingLinkRetry: "Tentar Novamente",
  whatsappBspOnboardingLinkTimeout:
    "O onboarding não foi completado. Por favor, complete o processo no portal e marque o checkbox.",
  whatsappBspOnboardingLinkChecking: "Caso já tenha concluído o cadastro no portal, clique no botão abaixo para verificar e avançar.",
  whatsappBspOnboardingLinkComplete: "Onboarding completo! Prosseguindo...",
};

